import { render, staticRenderFns } from "./Drawings.vue?vue&type=template&id=f833ac4a&scoped=true&"
import script from "./Drawings.vue?vue&type=script&lang=js&"
export * from "./Drawings.vue?vue&type=script&lang=js&"
import style0 from "./Drawings.vue?vue&type=style&index=0&id=f833ac4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f833ac4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VCol,VContainer,VRow})
